import UniversalSearch from "components/Organisms/UniversalSearch"
import AppSidebar, { SubNav } from "components/sidebar/app-sidebar"
import SidebarItem from "components/sidebar/sidebar-item"
import useAuth from "hooks/useAuth"
import { useAuthenticatedRoutes } from "hooks/useAuthenticatedRoutes"
import React, { useEffect } from "react"
import { VesaRouteType } from "routes"
import mainRoutes from "routes/main.routes"
import ReactGA from "../../services/analytics.service"
import AppHeader from "./AppHeader"
const Layout = ({ children }) => {
  const data = useAuth()
  const userId = data?.user?.id
  const username = data?.user?.username

  useEffect(() => {
    if (userId) {
      ReactGA.set({
        userId,
        username,
      })
    }
  }, [userId, username])

  const validRoutes = useAuthenticatedRoutes({
    routes: mainRoutes,
  })

  return (
    <div className="vt-background">
      <AppSidebar>
        {validRoutes?.map(({ path, title, icon, children }) => {
          const subRoutes = children?.filter(
            (child: VesaRouteType) => child.icon && child.title
          )

          return (
            <SidebarItem
              desc={title}
              key={path}
              path={path}
              icon={icon}
              submenu={subRoutes?.length > 0 ? true : false}
            >
              <SubNav routes={subRoutes} parentPath={path} />
            </SidebarItem>
          )
        })}
      </AppSidebar>
      <UniversalSearch />
      <div className="vt-content">
        <AppHeader />
        {children}
      </div>
    </div>
  )
}

export default Layout
